<template>
    <card class="card-plain">
        <list class="m-0 p-0"
              :columns="columns"
              v-model="users"
              :actionColumnLabel="$t('Select')">
            <template slot="header">
                <div class="col-lg-12 p-0">
                    <h4 class="d-inline m-0 p-1">{{ $t('Result selection') }}</h4>
                </div>
                <fg-input class="pt-2 pb-2 btn-one-size-dropdown">
                    <el-select size="large"
                               class="select-primary"
                               :placeholder="$t('Time frame')"
                               fullWidth
                               @input="setMonthsFilter"
                               :value="months">
                        <el-option v-for="option in monthsOptions"
                                   :value="option.value"
                                   :label="$t(option.label)"
                                   :key="option.value">
                        </el-option>
                    </el-select>
                </fg-input>
            </template>
            <template slot="actionsByRow" slot-scope="props">
                <router-link tag="a" :to="{ name: 'WavelineUserView', params: { qid: $route.params.qid, tid: $route.params.tid, uid: props.row._id } }">
                    <p-button round type="primary" size="sm" icon>
                        <i class="fa fa-arrow-right"/>
                    </p-button>
                </router-link>
            </template>
        </list>
    </card>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { Select, Option } from 'element-ui'
  import List from '../../Dashboard/Components/BasicList'

  export default {
    name: 'UserSelection',
    components: {
      List,
      [Select.name]: Select,
      [Option.name]: Option
    },
    data () {
      return {
        sf: 'username',
        so: 'asc',
        columns: [
          { name: 'username', text: 'User', formatter: this.userFormatter, sortable: false, align: 'left', minWidth: 150 }
        ]
      }
    },

    async mounted () {
      this.init()
    },

    computed: {
      ...mapState('user/waveline', {
        wavelineOverview: state => state.wavelineOverview,
        months: state => state.months,
        monthsOptions: state => state.monthsOptions,
      }),
      ...mapState('user/waveline/teamsByQuestionnaire', {
        questionnaire: state => state.questionnaireObj
      }),
      ...mapState('user/waveline/usersByTeam', {
        team: state => state.team
      }),
      ...mapGetters({ getTeams: 'user/waveline/teamsByQuestionnaire/getTeams' }),
      ...mapGetters({ getUsers: 'user/waveline/usersByTeam/getUsers' }),
      users: function () {
        return this.getUsers(this.$route.params.qid, this.$route.params.tid)
      },
      teams: function () {
        return this.getTeams(this.$route.params.qid)
      },
      breadcrumb: function () {
        const breadcrumb = []

        const { qid, tid, uid } = this.$route.params
        if (this.questionnaire) {
          breadcrumb.push({ name: 'WavelineQuestionnaireSelection', label: this.$options.filters.languageString(this.questionnaire.title) })
        }

        if (tid && this.team) {
          breadcrumb.push({ name: 'WavelineTeamSelection', params: { qid, tid }, label: this.team.title })
        }

        breadcrumb.push({ label: 'User selection' })

        return breadcrumb
      }
    },

    methods: {
      ...mapActions('user/waveline/usersByTeam', ['getList']),
      ...mapActions('user/waveline', ['setMonthsFilter', 'initPackageMonthsOptions']),
      async init () {
        this.initPackageMonthsOptions(this.$auth.user.customer.settings.contract.packageType)
        await this.fetchUsers()

        // console.log(this.breadcrumb)
        
        this.$store.commit('breadcrumb/SET_ROUTE_DATA', {
          path: this.$route.path,
          breadcrumb: this.breadcrumb
        }, { root: true })
      },
      async fetchUsers () {
        await this.getList({ questionnaireId: this.$route.params.qid, teamId: this.$route.params.tid, sf: 'firstName', so: 'asc', months: this.months })
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      userFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDisplayName(row)
      }
    },

    watch: {
      months (val) {
        if (val) {
          this.fetchUsers()
        }
      },
      async '$route.params.tid' (val) {
        if (val.length > 1) {
          this.init()
        }
      },
      breadcrumb () {
        console.log(this.breadcrumb)
        this.$store.commit('breadcrumb/SET_ROUTE_DATA', {
          path: this.$route.path,
          breadcrumb: this.breadcrumb
        }, { root: true })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }
  }
</style>